import {
  HatchPatternId,
  getHatchPatternFill,
} from 'pages/Shipments/HistoricalPerDiem/components/Patterns';
import * as React from 'react';
import { HorizontalBar } from './types';

export const Bar: React.FC<HorizontalBar> = (props) => {
  const { normalizedLength, blueProportion, redProportion, variant } = props;
  return (
    <div
      className="w-full h-2 rounded-full flex overflow-hidden"
      style={{
        width: `${normalizedLength * 100}%`,
      }}
    >
      {redProportion > 0 && (
        <div className="h-full bg-red-400" style={{ width: `${redProportion * 100}%` }}>
          {variant === 'historic' && (
            <svg className="w-full h-full">
              <rect
                width="100%"
                height="100%"
                fill={getHatchPatternFill(HatchPatternId.NonDisputable)}
              />
            </svg>
          )}
        </div>
      )}
      {blueProportion > 0 && (
        <div className="h-full bg-blue-700" style={{ width: `${blueProportion * 100}%` }}>
          {variant === 'historic' && (
            <svg className="w-full h-full">
              <rect
                width="100%"
                height="100%"
                fill={getHatchPatternFill(HatchPatternId.Disputable)}
              />
            </svg>
          )}
        </div>
      )}
    </div>
  );
};
Bar.displayName = 'HorizontalGraph.Bar';
